import React from 'react';

import './style.scss';

const DotsLoader = () => (
  <div className="spinner">
    <div className="bounce1" />
    <div className="bounce2" />
    <div className="bounce3" />
  </div>
);

export default DotsLoader;
